import _ from 'lodash';

// Local polyfill for `Object.entries`
const objectEntries = function(object) {
  return Object.keys(object).map(function(key) {
    return [key, object[key]];
  });
};

const makeProducts = function(name, id, terms) {
  var addOns = terms.available_add_ons || [];

  const termsToProducts = function(result, [term, product]) {
    /**
     * Skip "available_add_ons".
     * Add ons exist at the same level as terms in the products tree.
     */
    if (term === 'available_add_ons') {
      return result;
    }

    if (term === 'null') {
      term = null;
    }

    const productId = id.concat(term ? [term] : [])
      .join('-')
      .toLowerCase();

    product = _.cloneDeep(product);
    product.addOns = _.cloneDeep(addOns);
    product.term = term;
    product.name = name;
    product.id = productId;

    result.push(product);

    return result;
  };

  return objectEntries(terms)
    .reduce(termsToProducts, []);
};

const makeDomainProducts = function(key, domainTree) {
  const domainsToProducts = function(result, [tld, terms]) {
    const products = makeProducts(key, [key, tld], terms);

    products.map(function(product) {
      product.tld = tld;
    });

    return result.concat(products);
  };

  return objectEntries(domainTree)
    .reduce(domainsToProducts, []);
};

const makeProductsList = function(productsTree) {
  const treeToProducts = function(result, [key, value]) {
    let products;

    if (key.indexOf('domain') >= 0) {
      products = makeDomainProducts(key, value);
    } else {
      products = makeProducts(key, [key], value);
    }

    return result.concat(products);
  };

  return objectEntries(productsTree)
    .reduce(treeToProducts, []);
};

export default makeProductsList;
